import { render, staticRenderFns } from "./CategoryFilter.vue?vue&type=template&id=3813e92e&"
import script from "./CategoryFilter.vue?vue&type=script&lang=ts&"
export * from "./CategoryFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports